// const base_url = 'http://localhost:1919'
// const base_url = 'http://164.52.215.8:9090/FunnyBoneMtn'
const base_url = 'https://backendeureka.gameit.in'
// const base_url = 'http://192.168.1.12:7879'
// const base_url = ``
export {base_url}


const get_categories = `${base_url}/category`
export {get_categories}

const get_all_videos = `${base_url}/all`
export {get_all_videos};


const Subscribe_api = `${base_url}/subscribe`
export {Subscribe_api}

const check_api = `${base_url}/check`
export {check_api}

const header_api = `${base_url}/header`
export {header_api}

const script_api = `${base_url}/script/`
// const script_api  = `http://192.168.1.12:7879/script/`
export {script_api}


const check_subscription_api = `${base_url}/checkUser`
export {check_subscription_api}

const misData = `${base_url}/misdata`
// const misData = 'http://164.52.215.8:7879/misdata'
export {misData}


const unsub_api = `${base_url}/unsubscribe`
export {unsub_api}

const post_content_detail = `${base_url}/contentInfo`
export {post_content_detail}




